import { createModule } from '../../createModule';
import { buildFilesFormData, parseInput } from '../../shared';
import * as SwapaggSchemas from './swapagg.schemas';
export const createSwapaggAPI = createModule(({ http }) => ({
    getSwapagg: async () => {
        const res = await http.get('/v2/mappings/swapagg_mappings');
        return res;
    },
    getControl: async (params) => {
        const res = await http.get('/v2/mappings/swapagg_control', {
            params,
        });
        return res;
    },
    getMappings: async () => {
        const res = await http.get('/v2/mappings/external_mappings');
        return res;
    },
    getMissingExternalMappings: async (params) => {
        const res = await http.get('/v2/mappings/missing_external_mappings', {
            params,
        });
        return res;
    },
    uploadMappings: async (params) => {
        const body = parseInput(SwapaggSchemas.uploadMappingsSchema, params);
        const res = await http.post('/v2/mappings/external_mappings/file', {
            body: buildFilesFormData('files', body.files),
        });
        return res;
    },
    addMapping: async (params) => {
        const body = parseInput(SwapaggSchemas.addMappingSchema, params);
        const res = await http.post('/v2/mappings/external_mapping', {
            body,
        });
        return res;
    },
    deleteMapping: async (params) => {
        const body = parseInput(SwapaggSchemas.deleteMappingSchema, params);
        const res = await http.delete(`/v2/mappings/external_mapping/id/${body.id}`);
        return res;
    },
    /**
     * Update a mapping to SWAPAGG
     */
    updateSwapaggMapping: async (params) => {
        const body = parseInput(SwapaggSchemas.updateSwapaggMappingSchema, params);
        const res = await http.patch('/v2/mappings/swapagg_mapping', {
            body,
        });
        return res;
    },
    /**
     * Add a new mapping to SWAPAGG
     */
    addSwapaggMapping: async (params) => {
        const body = parseInput(SwapaggSchemas.addMappingToSwapaggSchema, params);
        const res = await http.post(`/v2/mappings/swapagg/ctrl/entry${body.input_type === 'aswap' ? '/aswap' : ''}`, {
            body,
        });
        return res;
    },
    /**
     * Add an existing mapping to SWAPAGG
     */
    pushMappingToSwapagg: async (params) => {
        const body = parseInput(SwapaggSchemas.pushMappingToSwapaggSchema, params);
        const res = await http.post(`/v2/mappings/swapagg_mapping/id/${body.id}`);
        return res;
    },
    /**
     * Remove a mapping to SWAPAGG
     */
    deleteSwapaggMapping: async (params) => {
        const body = parseInput(SwapaggSchemas.deleteSwapaggMappingSchema, params);
        const res = await http.delete(`/v2/mappings/swapagg_mapping/id/${body.id}`);
        return res;
    },
}));
